import { Component, OnInit, input } from '@angular/core';

@Component({
    selector: 'esp-discovery-results',
    templateUrl: './discovery-results.component.html',
    styleUrls: ['./discovery-results.component.scss'],
    host: { 'class': 'esp-discovery-results' },
    standalone: true
})
export class DiscoveryResultsComponent implements OnInit {

    readonly count = input(0, { alias: "resultsCount" });
    readonly show = input(false, { alias: "showResults" });
    readonly view = input<'tiles' | 'list'>('tiles');
    readonly width = input(780, { alias: "maxWidth" });

    constructor() { }

    ngOnInit() {
    }

}
